/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

import { tId } from './common';
import { EQUIVALENCY_TYPE, PRODUCT_TYPE, tRuleProduct } from './schemas';

const tCartLimitPolicyStoreOptional = t.partial({
  address: t.string,
});

const tCartLimitPolicyStoreRequired = t.type({
  id: tId,
  name: t.string,
  city: t.union([t.string, t.null]),
  state: t.union([t.string, t.null]),
  recreational: t.boolean,
});

const tCartLimitPolicyStore = t.intersection([
  tCartLimitPolicyStoreOptional,
  tCartLimitPolicyStoreRequired,
]);

const tCartLimitRuleRequiredV2 = t.type({
  limit_unit: t.string,
  limit_value: t.string,
  product_group_name: t.string,
  product_types: t.array(tRuleProduct),
  rule_type: t.union([t.literal(PRODUCT_TYPE), t.literal(EQUIVALENCY_TYPE)]),
});

const tCartLimitRuleOptionalV2 = t.partial({
  id: tId,
  _destroy: t.union([t.null, t.boolean]),
});

const tCartLimitRuleV2 = t.intersection([
  tCartLimitRuleRequiredV2,
  tCartLimitRuleOptionalV2,
]);

export const tCartLimitPolicyV2 = t.type({
  id: tId,
  name: t.string,
  stores: t.array(tCartLimitPolicyStore),
  cart_limit_rules: t.array(tCartLimitRuleV2),
});

export const tAbbreviatedCartLimitPolicy = t.type({
  id: tId,
  name: t.union([t.string, t.null]),
});

export type CartLimitRuleV2 = t.TypeOf<typeof tCartLimitRuleV2>;
export type CartLimitPolicyV2 = t.TypeOf<typeof tCartLimitPolicyV2>;
export type CartLimitPolicyStoreV2 = t.TypeOf<typeof tCartLimitPolicyStore>;
